export default function PrivacyPolicy() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 prose prose-sm">
      <h1 className="text-2xl font-bold text-ink-900 mb-2">Personvernerklæring</h1>
      <p className="text-[12px] text-ink-500">Sist oppdatert: 7. april 2026</p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">1. Hvem er behandlingsansvarlig?</h2>
      <p className="text-[13px] text-ink-700">
        Contrack AS er behandlingsansvarlig for personopplysningene som behandles i tjenesten.
        Kontakt: support@contrack.ai
      </p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">2. Hvilke data samler vi inn?</h2>
      <ul className="text-[13px] text-ink-700 list-disc pl-6">
        <li>Kontaktinformasjon (navn, e-post, telefon)</li>
        <li>Påloggingsdata (e-post, hashet passord, IP-adresse, sesjonsdata)</li>
        <li>Forretningsdata du laster opp (fakturaer, kontrakter, prosjekter)</li>
        <li>Bruksdata (audit log, handlinger i systemet)</li>
      </ul>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">3. Formål</h2>
      <p className="text-[13px] text-ink-700">
        Dataene brukes til å levere fakturakontroll-tjenesten, oppfylle bokføringskrav,
        og forbedre AI-analysen. Vi selger aldri data til tredjepart.
      </p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">4. Tredjeparter</h2>
      <p className="text-[13px] text-ink-700">
        Vi bruker følgende underleverandører: Microsoft Azure (lagring/hosting), Anthropic (AI-analyse),
        Azure Document Intelligence (PDF-ekstraksjon). Alle har databehandleravtale.
      </p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">5. Lagringstid</h2>
      <p className="text-[13px] text-ink-700">
        Forretningsdata lagres i minimum 5 år iht. bokføringsloven § 13.
        Personopplysninger slettes innen 30 dager etter at kundeforholdet opphører,
        med mindre lagringsplikt gjelder.
      </p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">6. Dine rettigheter</h2>
      <p className="text-[13px] text-ink-700">
        Du har rett til innsyn, retting, sletting, dataportabilitet og å klage til Datatilsynet.
        Bruk &quot;Slett konto&quot; i Innstillinger eller kontakt support@contrack.ai.
      </p>

      <h2 className="text-lg font-semibold text-ink-900 mt-6">7. Cookies</h2>
      <p className="text-[13px] text-ink-700">
        Vi bruker kun teknisk nødvendige cookies (auth-token i localStorage). Ingen sporing.
      </p>
    </div>
  );
}
